import { Map } from 'immutable';
import { actionTypes } from './actions';
import { createReducer } from 'utils/redux';
const initialState = new Map({
  loading: false,
  UNEXPLAINED_PAYMENTS: null,
  ADMINISTRATIVE_FINES: null,
  INCOME_DATA: null,
  INSURANCE_TAXES: null,
  SELF_PAID_INSURANCE_TAXES: null,
  LK_20_NOTIFICATIONS: null,
  error: null,
});

const onStart = (state) => state.set('loading', true).set('error', null);

const onSuccess = (state, { payload }) =>
  Map({
    ...state.toJS(),
    ...payload,
    loading: false,
    error: null,
  });

const onError = (state, { payload }) => state.set('loading', false).set('error', payload);

export default createReducer(initialState, {
  [actionTypes.HAS_UNITS_REQUEST_START]: onStart,
  [actionTypes.HAS_UNITS_REQUEST_SUCCESS]: onSuccess,
  [actionTypes.HAS_UNITS_REQUEST_FAILURE]: onError,
});
